import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { RiskFactors } from "@/features/risk/components/risk-factors"
import { RiskMoved } from "@/features/risk/components/risk-moved"
import { RiskNetwork } from "@/features/risk/components/risk-network"
import { RiskStanding } from "@/features/risk/components/risk-standing"
import { riskQueries } from "@/queries/risk"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/risk/"
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(riskQueries.network()),
  component: RiskPage,
})

function RiskPage() {
  return (
    <>
      <PageHeader title="Risk" />
      <div className="flex flex-col gap-10">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
          <RiskStanding />
          <RiskNetwork />
        </div>
        <RiskFactors />
        <RiskMoved />
      </div>
    </>
  )
}
